import Vue from 'vue'
import Router from 'vue-router'
import AnaSayfa from '@/components/AnaSayfa'
import SatinAl from '@/components/SatinAl'
import Kamp from '@/components/KampProgramlari'
import Login from '@/components/Login'
import UserMain from '@/components/UserMain'
import UyeOl from '@/components/UyeOl'
import Sinav from '@/components/Sinav'
import SinavOzeti from '@/components/SinavOzeti'
import SinavDetay from '@/components/SinavDetay'
import VideoGoster from '@/components/VideoGoster'
import VideoGosterJS from '@/components/VideoGosterVideoJS'
import Callback from '@/components/Callback'
import store from '../store.js'
Vue.use(Router)

let router = new Router({
  scrollBehavior: (to, from, savedPosition) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (savedPosition) {
          resolve(savedPosition)
        } else {
          resolve({ x: 0, y: 0 })
        }
      }, 500)
    })
  },
  mode: 'history',
  routes: [
    {
      name: 'callback',
      path: '/callback',
      component: Callback
    },
    {
      path: '/',
      name: 'AnaSayfa',
      component: AnaSayfa
    },
    {
      path: '/satinal',
      name: 'SatinAl',
      component: SatinAl
    },
    {
      path: '/eyds-hazirlik-kamp-programlari',
      name: 'KampProgramlari',
      component: Kamp
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/uyeol',
      name: 'UyeOl',
      component: UyeOl
    },
    {
      path: '/usermain',
      name: 'UserMain',
      component: UserMain,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/sinavlarim',
      name: 'Sinavlarim',
      component: UserMain,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/sinav/:sinavid',
      name: 'Sinav',
      component: Sinav,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/sinavozeti/:sinavid',
      name: 'SinavOzeti',
      component: SinavOzeti,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/sinavdetayi/:denemeid',
      name: 'SinavDetay',
      component: SinavDetay,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/videogoster/:url/:videoadi/:embedcode',
      name: 'VideoGoster',
      component: VideoGoster,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/videogosterjs/:url/:videoadi/:embedcode',
      name: 'VideoGosterJS',
      component: VideoGosterJS,
      meta: {
        requiresAuth: true
      }
    }
  ]
})
router.beforeEach((to, from, next) => {
  console.log('Değişiyor' + store.state.loggedin)
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.state.loggedin === false) {
      console.log(`Giriş Yapılmamış Login'e Yönlendiriliyor!`)
      next({
        path: '/login',
        params: {nextUrl: to.fullPath}
      })
    } else {
      console.log(`Giriş Yapılmış`)
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js